// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/@storybook/builder-webpack5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@storybook/builder-webpack5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* remove the docs wrapper bg to let page bg show through */
/* remove unnecessary padding now that theme switcher is not taking up space */
#storybook-docs .sbdocs-wrapper {
  background: transparent !important;
  padding-top: 0;
}

/* sb-show-main is missing during page transitions causing a page shift */
/* todo: cleanup once we no longer inherit docs-root */
.sb-show-main.sb-main-fullscreen,
.sb-main-fullscreen {
  margin: 0;
  padding: 0;
  display: block;
}

/* remove loading overlay */
.sb-preparing-story,
.sb-preparing-docs,
.sb-nopreview,
.sb-errordisplay {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./.storybook/docs-root-v9.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D,8EAA8E;AAC9E;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,yEAAyE;AACzE,sDAAsD;AACtD;;EAEE,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;;;;EAIE,wBAAwB;AAC1B","sourcesContent":["/* remove the docs wrapper bg to let page bg show through */\n/* remove unnecessary padding now that theme switcher is not taking up space */\n#storybook-docs .sbdocs-wrapper {\n  background: transparent !important;\n  padding-top: 0;\n}\n\n/* sb-show-main is missing during page transitions causing a page shift */\n/* todo: cleanup once we no longer inherit docs-root */\n.sb-show-main.sb-main-fullscreen,\n.sb-main-fullscreen {\n  margin: 0;\n  padding: 0;\n  display: block;\n}\n\n/* remove loading overlay */\n.sb-preparing-story,\n.sb-preparing-docs,\n.sb-nopreview,\n.sb-errordisplay {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
